module.exports = __webpack_public_path__ + "static/vid-0958720ae274c1041f39ceee02c92c77.svg";